import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigate, useSearchParams } from 'react-router';

import { notifications } from '@mantine/notifications';
import { IconCheck, IconMoodPuzzled } from '@tabler/icons-react';

import { useAppDispatch } from '@xver/hooks/useAppDispatch';
import { Endpoints } from '@xver/apis';
import { requestAuthUser } from '@xver/store/auth/auth.actions';
import storage from '@xver/utils/storage';
import { LoadingScreen } from '../../../components/Organisms';

export default function EmailVerificationPage() {
    const [searchParams] = useSearchParams();
    const ref = searchParams.get('ref');
    const token = searchParams.get('token');
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { t } = useTranslation('notifications');

    useEffect(() => {
        if (!ref || !token) {
            navigate('/', { replace: true });
            return;
        }

        sessionStorage.setItem('xver:reminded:email:suppress', '1');

        Endpoints.v1.Authentication.verifyEmail(ref, token)
            .then(async (response) => {
                if (response?.token) {
                    storage.set('_zugang', response.token);

                    notifications.show({
                        title: t('auth.emailVerifiedTitle'),
                        message: t('auth.emailVerifiedRedirecting'),
                        icon: <IconCheck size={32} color={'#00ff00'} />,
                    });

                    await dispatch(requestAuthUser());

                    navigate('/dashboard', { replace: true });
                    return;
                }
            })
            .catch(({ message }: any) => {
                sessionStorage.removeItem('xver:reminded:email:suppress');
                notifications.show({
                    title: t('auth.emailVerificationFailedTitle'),
                    message: message || t('auth.emailVerificationFailedMessage'),
                    icon: <IconMoodPuzzled size={32} color={'#eb5757'} />,
                });
                navigate('/', { replace: true });
            });
    }, [ref, token, navigate, t, dispatch]);

    return <LoadingScreen />;
}
